export default "__VITE_ASSET__DBIL86f7__"